@if (('debug' | userPermission | async) && debug()) {
	<div style="padding-top: 80px;"> DB: {{ debug().database }}</div>
	<div> Version: {{ debug().version }}</div>
	<div> SysInfo: {{ debug().system }}</div>
	<div> Kubernetes: {{ debug().kubernetes }}</div>
	@if (debug().newsletterGroupName) {
		<div>
			{{ 'frame.footer.newsletterid' | msgKey:[{ '%id%': debug().newsletterGroupName }] }}
		</div>
	}
}
